import React, { useState } from "react";
import { Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";

const TRissues = () => {
  const [selectedOption, setSelectedOption] = useState("none");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="MajorConcernsContainer">
      {/* Dropdpwn for Community Engagement Issues */}
      <Box sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column", // Mobile: stack
              sm: "row", // Tablet/Desktop: inline
            },
            alignItems: {
              xs: "flex-start",
              sm: "center",
            },
            gap: 2, // adds spacing between text and dropdown
          }}
        >
          <Typography className="issues-area-helper">Key Issues In</Typography>

          <FormControl
            variant="filled"
            sx={{
              width: {
                xs: "100%",
                sm: 300,
              },
            }}
            className="AreaFormControl"
          >
            <Select
              labelId="Area-label"
              id="Area"
              value={selectedOption}
              onChange={handleChange}
              displayEmpty
            >
              <MenuItem value="none">
                <em>-- Select an area --</em>
              </MenuItem>
              <MenuItem value="Evinston">Evinston</MenuItem>
              <MenuItem value="Gordon">Gordon</MenuItem>
              <MenuItem value="Hawthorne">Hawthorne</MenuItem>
              <MenuItem value="IslandGrove">Island Grove</MenuItem>
              <MenuItem value="Melrose">Melrose</MenuItem>
              <MenuItem value="Micanopy">Micanopy</MenuItem>
              <MenuItem value="Monteocha">Monteocha</MenuItem>
              <MenuItem value="OrangeHeights">Orange Heights</MenuItem>
              <MenuItem value="Rochelle">Rochelle</MenuItem>
              <MenuItem value="Waldo">Waldo</MenuItem>
              <MenuItem value="Windsor">Windsor</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      {/* Concerns for selected are to be displayed */}
      <div className="MajorConcernsData">
        {selectedOption === "none" && (
          <Typography variant="body2">
            <p className="ZeroBottomMargin">
              Please select an area from the above dropdown to view
              transportation concers related to it.
            </p>
          </Typography>
        )}{" "}
        {selectedOption === "OrangeHeights" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Evinston" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Gordon" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Hawthorne" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Ensure safety for school children crossing major roads</li>
              <li>
                Lack of hurricane shelters in town, especially for mandatory
                evacuations
              </li>
              <li>
                Increase transportation and transit options for better
                accessibility
              </li>
              <li>Adjust bus hours to align with working hours</li>
              <li>Address speeding problems on local roads</li>
              <li>Improve enforcement of speed zones and speed limits</li>
              <li>
                Safety concerns with speeding semi trucks on CR 234; need to
                enforce the "no trucks" policy
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "IslandGrove" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Trucks speeding on CR 325 are a safety concern</li>
              <li>CR 177 has potholes due to heavy farm traffic</li>
              <li>The road from 20th to 346 also needs repairs</li>
              <li>
                Kate Barnes Park boat ramp needs ADA upgrades and restoration
              </li>
              <li>
                Residents are getting ticketed at Long Bridge—unclear
                enforcement
              </li>
              <li>Only two sheriffs, and not always on duty</li>
              <li>Paper-only tickets make enforcement harder for deputies</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Melrose" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Speeding and reckless driving are major concerns on SR 26, SR
                21, 219A
              </li>
              <li>
                Residents suggested more law enforcement presence, better
                signage, and possibly using old police cars or radar signs to
                slow traffic
              </li>
              <li>
                Cut-through traffic and large trucks disturb residential
                neighborhoods like Grove, Center, Quail St, and Hampton
              </li>
              <li>
                There’s a need for better traffic flow and timing at key
                intersections, especially during school and rush hours
              </li>
              <li>
                Lack of school buses for Melrose students due to the school
                being in Putnam County
              </li>
              <li>Poor maintenance of limestone roads like Quail Street</li>
              <li>
                No public transportation options and questions about extending
                RTS
              </li>
              <li>
                Requests for bike trails, sidewalks, and a crosswalk on Trout
                Street
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Micanopy" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Heavy traffic from I-75 during mornings and rush hour; law
                enforcement does not manage accidents
              </li>
              <li>Green turn light needed at FDOT 234/441 Southbound</li>
              <li>
                Speed bumps on CR 234, Tuscawilla, and Seminary Avenue need
                repainting to help reduce speeding
              </li>
              <li>
                Trucks and tractor trailers driving on rural roads where they
                are not permitted
              </li>
              <li>
                Road repair needed on 345 and 325, especially turning left from
                345 onto 325 due to poor road conditions
              </li>
              <li>
                RTS runs empty buses through Micanopy but do not pick up
                residents{" "}
              </li>
              <li>
                Seniors would benefit from increased public transportation for
                food and medical access
              </li>
              <li>
                Youth would benefit from increased public transportation to
                access more economic and extracurricular opportunities
              </li>
              <li>
                Huge need for reasonable and reliable public transportation
                options
              </li>
              <li>Establish an RTS park and ride stop in Micanopy</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Monteocha" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Need for a paved road from CR 192 to Atlas Ame Church</li>
              <li>
                A 15-year-old road development project on CR 231 at CR 156
                stalled after only the base layer was completed; follow-up is
                needed
              </li>
              <li>
                The flashing light at CR 156 & CR 225 was lost in Hurricane
                Helene and needs to be replaced; the current sign is not visible
                at night
              </li>
              <li>
                The apron from CR 192 to private property needs adjustments to
                soften the drop-off
              </li>
              <li>
                Semi-trucks are driving through CR 192 to CR 21 and on CR 156,
                causing safety concerns
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Rochelle" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                The stretch of County Road 234 from Micanopy to 282 needs to be
                repaved
              </li>
              <li>
                Additional County Road 234 concerns:
                <ul>
                  <li>Big commercial trucks are abundant on 234</li>
                  <li>
                    Speeding concerns on 234 – more law enforcement is needed
                  </li>
                  <li>Current pot holes on 234 are not being patched well</li>
                  <li>Shoulders are needed on 234</li>
                  <li>A bike lane or sidewalk along 234 is needed </li>
                </ul>
              </li>
              <li>
                There is a dangerous intersection where 234 and highway 20 meet
              </li>
              <li>A right lane is needed on 234 onto highway 20 </li>
              <li>Request for RTS service from Rochelle to Gainesville </li>
              <li>
                A portion of 282 was closed, which raises concerns and
                frustration
              </li>
              <li>
                Oak trees need to be trimmed so they do not hit semi-trucks
              </li>
              <li>Need for a place to dump old tires </li>
              <li>Need for better parking options at the parks </li>
              <li>‘No Commercial Truck’ signs are not reinforced </li>
              <li>
                Blinking light needed where 283 and 234 intersect near the
                church
              </li>
              <li>Desire for a horse crossing sign on 234 near the church</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Waldo" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Dangerous speeds on 301 and SR 24</li>
              <li>Lack of police presence to manage speed issues</li>
              <li>Need for better pedestrian safety</li>
              <li>
                Make Waldo safer to walk and bike, with improved markings and
                wheelchair accessibility
              </li>
              <li>Inconsistent school bus transportation outside of Waldo</li>
              <li>Cars running through red lights at the Starke Bypass</li>
              <li>Create more parking options downtown</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Windsor" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>CR 234 near Windsor is damaging vehicles—needs repaving</li>
            </ul>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default TRissues;
